import { render, staticRenderFns } from "./WysiwygSurveyTemplateBuilder.vue?vue&type=template&id=488b9394&scoped=true"
import script from "./WysiwygSurveyTemplateBuilder.vue?vue&type=script&lang=js"
export * from "./WysiwygSurveyTemplateBuilder.vue?vue&type=script&lang=js"
import style0 from "./WysiwygSurveyTemplateBuilder.vue?vue&type=style&index=0&id=488b9394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488b9394",
  null
  
)

export default component.exports